pageId = 'page-set-leave-calendar'
page = "##{ pageId }"

$ ->
  $(document).on 'click', "#{ page } .calendars .calendar", ->
    $calendar = $(@)
    $form = $calendar.closest('.form')
    $form.find('.active').removeClass 'active'
    $calendar.addClass 'active'
    if $calendar.hasClass 'new'
      $calendar.find('input').focus()
      $form.addClass 'new'
    else
      $form.find('input[name=calendar_guid]').val $calendar.data('guid')
      $form.removeClass 'new'

  .on 'keydown', "#{ page } .calendar.new input[type=text]", (e) ->
    if e.which is 13
      $('.link-new-calendar').trigger('click')

  .on 'click', "#{ page } .link-toggle-section", ->
    $('.modify-calendar').slideUp 'fast', ->
      $('.choose-calendar').slideDown('fast')

  .on 'click', "#{ page } .form .btn-x", ->
    $('.choose-calendar').slideUp 'fast', ->
      $('.modify-calendar').slideDown('fast')

  .on 'ajax:beforeSend', "#{ page } .form", ->
    $form = $(@)
    unless $form.find('.calendar.active').length
      $form.find('p.error').remove()
      $('<p class="error">请选择一个日历</p>').appendTo $form.find('.calendars')
      return false

  .on 'ajax:success', "#{ page } .form", ->
    tower.stack.load location.href,
      replace: true
      nocache: true

  $(document.body).on 'click', "#{ page } .link-new-calendar", ->
    $btn = $(@)
    $form = $btn.closest '.form'
    $input = $form.find('.calendar.new input[type=text]')
    if $input.val()
      $btn[0].href += "&name=#{ $input.val() }"
    else
      $form.find('p.error').remove()
      $('<p class="error">请输入日历名称</p>').appendTo $form.find('.calendars')
      return false

